<template>
  <div>
    <div style="height:92px">
      <el-input
        v-model="selectTotal"
        placeholder="请输入内容"
        style="margin-bottom: 10px"
      ></el-input>

      <el-input placeholder="输入关键字进行过滤" v-model="filterText">
      </el-input>
    </div>
    <div :class="readonly?'treestyle1':'treestyle'" v-loading="loading">
      <el-tree
        class="filter-tree"
        :data="menuData[0]"
        :props="defaultProps"
        show-checkbox
        node-key="id"
        highlight-current
        default-expand-all
        :default-checked-keys="menuCheckedList"
        :filter-node-method="filterNode"
        @check-change="clickDeal"
        ref="tree"
      >
      </el-tree>
    </div>
  </div>
</template>

<script>
import userApi from "@/api/api";
export default {
  props: {
    type: {
      type: String,
      default: "role",
    },
    userId: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      readonly: false,
      paramId: "",
      applicationList: [],
      menuData: [],
      buttonList: [],
      selectApplication: "",
      selectTreeNodeKey: "",
      resourceTypes: [],
      checkApplication: 0,
      defaultProps: {
        children: "children",
        label: "label",
      },
      checkedMenu: {
        buttonList: [],
      },
      menuCheckedList: [],
      buttons: [],
      buttonCheckFlag: false,
      menuHalfCheckedList: [],
      menuSendList: [],
      resourceSendTypes: [],
      authLoading: false,
      filterText: "",
      loading: false,
    };
  },
  computed: {
    selectTotal() {
      return `已选择${this.menuCheckedList.length}项`;
    },
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    creatEdit() {
      if (this.$route) {
        if (this.$route.query.id) {
          this.paramId = this.$route.query.id;
          this.handleAuthData();
        } else {
          this.paramId = "";
          this.handleAllResource();
        }
        if (
          this.$route.params.type === "view" ||
          this.$route.params.type === "auth"
        )
          this.readonly = true;
      } else {
        this.paramId = this.userId;
        this.handleAuthData();
      }
    },
    cencel() {
      this.creatEdit();
      this.menuCheckedList = [];
    },
    editMenuData(flag) {
      this.menuData[0].forEach((item) => {
        // if(item.disabled)
        item.disabled = flag;
        if (item.children) {
          this.changeArr(item.children, flag);
        }
      });
    },
    changeArr(arr, flag) {
      arr.forEach((item) => {
        item.disabled = flag;
        if (item.children) {
          this.changeArr(item.children, flag);
        }
      });
    },
    // 获取应用模块
    handleAuthData() {
      this.handleMenusAndButtons(1, 0);
    },
    // 角色新增时没有operationId，请求所有菜单按钮资源
    handleAllResource() {
      this.loading = true;
      userApi.initAllResourceTree({}).then((res) => {
        let menus = [];
        res.data.data.childResourceVoList.forEach((item) => {
          menus.push(this.handleMenu(item, 1));
        });

        this.$set(this.menuData, 0, menus);
        this.loading = false;
      });
    },
    handleMenusAndButtons(val, index, key) {
      this.loading = true;
      if (key == "edit") {
        this.readonly = false;
      } else if (key == "view") {
        this.readonly = true;
      }
      let type = this.type;
      let params = {
        applicationId: val,
        operationId: this.paramId,
        operationType: type == "user" ? 0 : 1,
      };
      userApi
        .queryMenuAndButton(params)
        .then((res) => {
          if (res.data && res.data.data) {
            let menus = [];
            res.data.data.resourceVo.childResourceVoList.forEach((item) => {
              menus.push(this.handleMenu(item, val));
            });

            this.$set(this.menuData, index, menus);
            this.loading = false;
          }
        })
        .catch((err) => {});
    },
    clickDeal(datas, checkeds, indeterminate) {
      if (checkeds) {
        this.menuCheckedList.push(datas.id);
      } else {
        let index = this.menuCheckedList.indexOf(datas.id);
        this.menuCheckedList.splice(index, 1);
      }

      let halfChecked = this.$refs.tree
        .getHalfCheckedNodes()
        .filter((item) => !item.disabled);
      let checked = this.$refs.tree
        .getCheckedNodes()
        .filter((item) => !item.disabled);
      let data = [...halfChecked, ...checked];
      let type = this.type;
      let params = {
        operationId: this.paramId,
        operationType: type == "user" ? 0 : 1,
        applicationPrivilegeVoList: [],
      };
      let obj = {};
      obj = {
        applicationId: 1,
        privilegeVoList: [],
      };
      obj.privilegeVoList.push({
        accessId: 1,
        accessType: 0,
        masterId: 1 * this.paramId,
        operationType: 2,
      });
      data.forEach((item) => {
        obj.privilegeVoList.push({
          accessId: 1 * item.id,
          accessType: 1,
          masterId: 1 * this.paramId,
          operationType: 2,
        });
      });
      params.applicationPrivilegeVoList.push(obj);
      this.$emit("authData", params);
    },
    // 菜单树形处理
    handleMenu(el, applicationId) {
      el.menuList = [];
      el.buttonList = [];
      if (!el.rootTree) {
        el.rootTree = applicationId;
      }
      if (!el.treeId) {
        el.treeId = `${applicationId}-${el.parentResourceId}-${el.id}`;
      }
      el.parentResourceId = `${el.parentResourceId}-${el.id}`;
      if (el.childResourceVoList && el.childResourceVoList.length > 0) {
        el.menuList = el.childResourceVoList.filter(
          (item) => item.resourceType == 1
        );
        el.buttonList = el.childResourceVoList.filter(
          (item) => item.resourceType == 2
        );
      }
      if (el.choiceFlag) {
        if (
          (el.childResourceVoList && el.childResourceVoList.length == 0) ||
          !el.childResourceVoList
        ) {
          if (this.menuCheckedList.indexOf(el.id) == -1) {
            this.menuCheckedList.push(el.id);
          }
        }
      }
      const haveChildren = Array.isArray(el.childResourceVoList);
      return {
        disabled: this.readonly || el.prohibitFlag ? true : false,
        checked: el.choiceFlag,
        label: `${el.resourceName}`,
        id: el.id,
        value: `${el.resourceCode}`,
        resourceCode: el.resourceCode,
        resourceType: el.resourceType,
        parentResourceId: `${applicationId}-${el.parentResourceId}`,
        childResourceVoList: { ...el },
        children: { ...el },
        menuList: el.menuList,
        buttonList: el.buttonList,
        treeId: el.treeId,
        rootTree: el.rootTree,
        choiceFlag: el.choiceFlag,
        children: haveChildren
          ? el.childResourceVoList.map((i) => this.handleMenu(i, applicationId))
          : null,
      };
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
  },
  created() {
    this.creatEdit();
  },
};
</script>

<style lang="less" scoped>
.treestyle {
  max-height: calc(100vh - 335px);
  overflow-y: auto;
}
.treestyle1 {
  max-height: calc(100vh - 285px);
  overflow-y: auto;
}
.treestyle::-webkit-scrollbar ,
.treestyle1::-webkit-scrollbar{
  display: none; /* Chrome Safari */
}
</style>
